import { render, staticRenderFns } from "./information-add-or-update.vue?vue&type=template&id=e2f8add4&scoped=true&"
import script from "./information-add-or-update.vue?vue&type=script&lang=js&"
export * from "./information-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./information-add-or-update.vue?vue&type=style&index=0&id=e2f8add4&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2f8add4",
  null
  
)

export default component.exports